module.exports = __webpack_public_path__ + "img/popup_error.5b3a9fad.png";